import request from '@/router/axios';
const urlPrefix = process.env.VUE_APP_LOCAL_DEVELOPMENT == 'true' ? '/sys' : '/sys'
export function getListpage(obj) {
  return request({
    url:urlPrefix+ '/info/getinfosetlistpage',
    method: 'post',
    data: obj
  })
}
export function delParameterById(id) {
    return request({

      url: urlPrefix+'/parameter/' + id,
      method: 'delete'
  })
}

export function addParameter(obj) {
    return request({
      url:urlPrefix+ '/parameter',

      method: 'post',
      data: obj
    })
}

export function updateParameter(obj) {
  return request({
    url: urlPrefix+'/parameter',
    method: 'put',
    data: obj
  })
}
export function checkParaKeyIsExists(paraKey, id) {
  return request ({
   url:urlPrefix+ '/parameter/parakeyisexists/' + paraKey + '/' + id,
   method: 'get',
   params: paraKey
  })
}

export function initInfo() {
  return request({
    url: urlPrefix+ '/init/cache/info',
    method: 'get'
  })
}
// 保存自定义表头
export function saveCustomHeader(obj) {
  return request({
    url: urlPrefix+ '/info/infoitemuser',
    method: 'post',
    data: obj
  })
}

export function saveInfoSet(obj){
  return request({
    url: urlPrefix + '/info/saveSysInfoSet',
    method: 'post',
    data: obj
  })
}

export function editSysInfoSet(obj){
  return request({
    url: urlPrefix + '/info/editSysInfoSet',
    method: 'post',
    data: obj
  })
}

export function checkInfoSetId(tenantId,infoSetId){
  return request({
    url: urlPrefix + '/info/checkInfoSetId',
    method: 'get',
    params:{
      tenantId: tenantId,
      infoSetId:infoSetId
    }
  })
}

export function changeSysInfoSetStatus(obj){
  return request({
    url: urlPrefix + '/info/changeSysInfoSetStatus',
    method: 'post',
    data:obj
  })
}

export function getSysInfoItemPage(obj){
  return request({
    url: urlPrefix + '/info/queryinfoitemlist',
    method: 'post',
    data: obj
  })
}

export function saveSysInfoItem(obj){
  return request({
    url: urlPrefix + '/info/saveSysInfoItem',
    method: 'post',
    data: obj
  })
}

export function editSysInfoItem(obj){
  return request({
    url: urlPrefix + '/info/editSysInfoItem',
    method: 'post',
    data: obj
  })
}
export function checkInfoItemId(tenantId,infoItemId,infoSetId){
  return request({
    url: urlPrefix + '/info/checkInfoItemId',
    method: 'get',
    params: {
      tenantId: tenantId,
      infoItemId: infoItemId,
      infoSetId:infoSetId
    }
  })
}

export function changeSysInfoItemStatus(obj){
  return request({
    url: urlPrefix + '/info/changeSysInfoItemStatus',
    method: 'post',
    data:obj
  })
}
//根据多个codeSetId获取代码项，用来翻译
export function getCodeItemList(codeSetIds,tenantId){
  return request({
    url: urlPrefix + '/info/translateData',
    method: 'get',
    params: {
      codeSetId: codeSetIds,
      tenantId: tenantId
    }
  })
}
